import React from 'react';
import { useSelector } from 'react-redux';
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from 'react-share';
import styles from './styles.module.scss';
import Config from '../../../config/config';

import { ReactComponent as ShareIcon } from '../../../assets/icons/icon-share.svg';
import { ReactComponent as ShareFacebook } from '../../../assets/icons/share-facebook.svg';
import { ReactComponent as ShareTwitter } from '../../../assets/icons/share-twitter.svg';
import { ReactComponent as ShareWhatsapp } from '../../../assets/icons/share-whatsapp.svg';
import { ReactComponent as ShareEmail } from '../../../assets/icons/share-email.svg';

const CopyLink = (url) => {
  navigator.clipboard.writeText(url);
  alert('Link copiado al portapapeles');
};

const Share = ({ cmsData }) => {
  const fboId = useSelector(
    (globalState) => globalState.referralInfo.referralId
  );
  const Port = Config.api_services.environment === 'TEST' ? ':1339' : '';
  const urlFbo = fboId ? `?fbo=${fboId}` : '';
  const url = `https://www.shopforeverliving.com.mx${Port}/mex/es-mx/product/${cmsData.SLUG}${urlFbo}`;
  return (
    <div className={styles.share}>
      <ShareIcon />
      <div className={styles.popup}>
        <div className={styles.icons}>
          <FacebookShareButton quote={cmsData.Name} url={url}>
            <ShareFacebook />
          </FacebookShareButton>
          <TwitterShareButton title={cmsData.Name} url={url}>
            <ShareTwitter />
          </TwitterShareButton>
          <WhatsappShareButton url={url} separator={cmsData.DescriptionSpanish}>
            <ShareWhatsapp />
          </WhatsappShareButton>
          <button type="button" onClick={() => CopyLink(url)}>
            <ShareEmail />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Share;
